<template>
	<div>
		<a-card style="width: 1100px">
			<a-page-header title="编辑商品" subTitle="打造你的小商铺~" >
				<a-tag color="red">本平台暂不支持运费核算，只支持包邮，谨慎填写价格！</a-tag>
			</a-page-header>
			<a-steps type="navigation" v-model="current" style="marginBottom: '40px';boxShadow: '0px -1px 0 0 #e8e8e8 inset'">
				<a-step :status="zero" title="商品信息" :disabled="zeroDisabled"><a-icon type="shopping" slot="icon" /></a-step>
				<a-step :status="one" title="商品促销" :disabled="oneDisabled"><a-icon type="rocket" slot="icon" /></a-step>
				<a-step :status="two" title="商品属性" :disabled="twoDisabled"><a-icon type="form" slot="icon" /></a-step>
			</a-steps>
			<a-form-model ref="storeInfo" v-if="current == 0" :model="storeInfo" style="margin-top: 50px;" :label-col="{ span: 4 }" :wrapper-col="{ span: 14 }">
				<a-form-model-item label="商品名称" required><a-input :maxLength="150" v-model="storeInfo.productName" placeholder="请输入商品名称!" /></a-form-model-item>
				<a-form-model-item label="商品分类" required>
					<a-select v-model="storeInfo.classify" placeholder="请输入商品分类!">
						<a-select-option :key="index" v-for="(item, index) in typeList" :value="item.id">{{ item.name }}</a-select-option>
					</a-select>
				</a-form-model-item>
				<!-- <a-form-model-item label="副标题" required><a-input v-model="storeInfo.subhead" placeholder="请输入副标题!" /></a-form-model-item> -->
				<!-- <a-form-model-item label="商品关键字"><a-input v-model="storeInfo.keyword" placeholder="请输入商品关键字!" /></a-form-model-item> -->
				<!-- <a-form-model-item label="商品介绍" required><a-input v-model="storeInfo.introduce" placeholder="请输入商品介绍!" type="textarea" /></a-form-model-item> -->
				<!-- <a-form-model-item label="商品货号" required><a-input v-model="storeInfo.productCode" placeholder="请输入商品货号!" /></a-form-model-item> -->
				<a-form-model-item label="排序">
					<a-input-number :min="0" :max="100" v-model="storeInfo.productSort" />
					<span class="ant-rate-text">数值越大越靠前（最大100）</span>
				</a-form-model-item>
				<a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
					<a-button type="primary" @click="onSubmit" :disabled="checkStoreInfo()">下一步，填写商铺促销</a-button>
				</a-form-model-item>
			</a-form-model>

			<a-form-model ref="storeMarket" v-if="current == 1" :model="storeInfo" style="margin-top: 35px;" :label-col="{ span: 4 }" :wrapper-col="{ span: 14 }">
				<!-- <a-form-model-item label="服务保证">
					<a-checkbox-group v-model="storePromotion.serve">
						<a-checkbox value="1" name="type">无忧退换</a-checkbox>
						<a-checkbox value="2" name="type">快速退款</a-checkbox>
						<a-checkbox value="3" name="type">免费包邮</a-checkbox>
					</a-checkbox-group>
				</a-form-model-item> -->
				<a-form-model-item label="商品上架"><a-switch v-model="storeInfo.putAway" /></a-form-model-item>
				<a-form-model-item label="线上交易"><a-switch v-model="storeInfo.onLinePay" disabled/><a-tag style="margin-left: 20px;" color="orange">交易方式为线上交易、线下交易</a-tag></a-form-model-item>
				<a-form-model-item label="商品起批量">
					<a-input-number :min="0" v-model="storeInfo.minShop" />
					<span class="ant-rate-text"><a-tag style="margin-left: 20px;" color="orange">商品多少件起卖，为0则不限制</a-tag></span>
				</a-form-model-item>
				<a-form-model-item label="商品推荐">
					<a-switch v-model="storeInfo.recommend" /><a-tag style="margin-left: 20px;" color="orange">推荐（将商品展示到帝全商城）</a-tag>
				</a-form-model-item>
				<!-- <a-form-model-item label="商品包邮">
					<a-switch v-model="storeInfo.postage" />
				</a-form-model-item> -->
				
				<a-form-model-item label="商品限购">
					<a-switch v-model="storeInfo.limit" />
					<a-tag style="margin-left: 20px;" color="orange">限购（一个用户只能购买一件）</a-tag>
				</a-form-model-item>
				
				<!-- <a-form-model-item  v-if="!storeInfo.postage" label="商品运费" required>
					<a-input-number :min="0" v-model="storeInfo.freight" />&nbsp;&nbsp;元
				</a-form-model-item> -->
				<a-form-model-item label="商城分类" v-if="storeInfo.recommend" required>
					<a-select v-model="storeInfo.mallClassify" placeholder="请输入商城分类!">
						<a-select-option :key="index" v-for="(item, index) in mallTypeList" :value="item.id">{{ item.name }}</a-select-option>
					</a-select>
				</a-form-model-item>
				<a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
					<a-button @click="last()">上一步，填写商品信息</a-button>
					<a-button style="margin-left: 20px;" type="primary" @click="onSubmit" :disabled="checkstorePromotion()">下一步，填写商品属性</a-button>
				</a-form-model-item>
			</a-form-model>

			<a-form-model v-if="current == 2" :model="commodityAttr" style="margin-top: 20px;" :label-col="{ span: 4 }" :wrapper-col="{ span: 14 }">
				<a-form-model-item label="商品主图" required>
					<el-upload
						list-type="picture-card"
						:action="QiniuURL"
						:data="QiniuData"
						:on-error="uploadError"
						:on-success="uploadSuccess"
						:before-upload="beforeStoreUpload"
						:limit="6"
						multiple
						:on-exceed="handleExceed"
						:file-list="bannerList"
					>
						<i slot="default" class="el-icon-plus"><div style="font-size: 14px;">商品相册(6张)</div></i>
						<div slot="file" slot-scope="{ file }">
							<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)"><i class="el-icon-zoom-in"></i></span>
								<span v-if="false" class="el-upload-list__item-delete" @click="handleDownload(file)"><i class="el-icon-download"></i></span>
								<span v-if="!disabled" class="el-upload-list__item-delete" @click="bannerRemove(file)"><i class="el-icon-delete"></i></span>
							</span>
						</div>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible"><img width="100%" :src="dialogImageUrl" alt="" /></el-dialog>
					
				</a-form-model-item>
				
				<!-- <a-form-model-item label="商品主图" required>
					<el-upload
						list-type="picture-card"
						:action="QiniuURL"
						:data="QiniuData"
						:on-error="uploadError"
						:on-success="uploadSuccessUpload"
						:before-upload="beforeStoreDetailUpload"
						:limit="15"
						multiple
						:on-exceed="handleExceed"
						:file-list="storeDetailList"
					>
						<i slot="default" class="el-icon-plus"><div style="font-size: 14px;">商品相册(6张)</div></i>
						<div slot="file" slot-scope="{ file }">
							<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)"><i class="el-icon-zoom-in"></i></span>
								<span v-if="false" class="el-upload-list__item-delete" @click="handleDownload(file)"><i class="el-icon-download"></i></span>
								<span v-if="!disabled" class="el-upload-list__item-delete" @click="bannerDetailRemove(file)"><i class="el-icon-delete"></i></span>
							</span>
						</div>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible"><img width="100%" :src="dialogImageUrl" alt="" /></el-dialog>
					
				</a-form-model-item> -->

				<a-form-model-item label="商品详情" required>
					<el-upload
						list-type="picture-card"
						:action="QiniuURL"
						:data="QiniuData"
						:on-error="uploadError"
						:on-success="uploadSuccessUpload"
						:before-upload="beforeStoreDetailUpload"
						:limit="15"
						multiple
						:on-exceed="handleExceed"
						:file-list="storeDetailList"
					>
						<i slot="default" class="el-icon-plus"><div style="font-size: 14px;">商品详情(15张)</div></i>
						<div slot="file" slot-scope="{ file }">
							<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
							<span class="el-upload-list__item-actions">
								<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)"><i class="el-icon-zoom-in"></i></span>
								<span v-if="false" class="el-upload-list__item-delete" @click="handleDownload(file)"><i class="el-icon-download"></i></span>
								<span v-if="!disabled" class="el-upload-list__item-delete" @click="bannerDetailRemove(file)"><i class="el-icon-delete"></i></span>
							</span>
						</div>
					</el-upload>
					<el-dialog :visible.sync="dialogVisible"><img width="100%" :src="dialogImageUrl" alt="" /></el-dialog>
					
				</a-form-model-item>
				
				<a-form-model-item label="商品详情描述">
					<a-textarea v-model="storeInfo.detailDescribe" placeholder="请输入商品详情描述"  />
				</a-form-model-item>
				
				<!-- <a-form-model-item>
					<div>
						<div style="color: red;width: 810px;
    margin-left: 170px;">
							注：以下价格以“分”为单位；比如：输入市场价格：999，实际显示金额是9.99元；市场价格不能低于售价（售价为帝全会员价）！
						</div>
					</div>
				</a-form-model-item> -->
					
				<a-form-model ref="dynamicValidateForm" :model="dynamicValidateForm" v-bind="formItemLayoutWithOutLabel">
					<a-form-model-item
						v-for="(domain, index) in dynamicValidateForm.domains"
						:key="domain.key"
						v-bind="index === 0 ? formItemLayout : {}"
						:label="index === 0 ? '商品规格' : ''"
						:prop="'domains.' + index + '.value'"
						:rules="{
							required: true,
							message: '请输入商品规格',
							trigger: 'blur'
						}"
					>
						<a-input :maxLength="150" @change="refleush(index)" v-model="domain.value" placeholder="请输入商品规格~(例如: 红色 尺寸40 大码)" style="width: 30%; margin-right: 8px" />
						库存：<a-input-number placeholder="库存" :max="9999999" :min="0" style=" margin-right: 8px" v-model="domain.ku" />
						市场价格(元)：
						<a-input-number
							placeholder="市场价格"
							:min="0.02"
							:max="9999999"
							style=" margin-right: 8px;width: 120px;"
							v-model="domain.bazaarPrice"
							@change="checkBazaarPrice(domain.bazaarPrice,domain.price,index)"
							:precision="2"
							:formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
							:parser="value => value.replace(/\￥\s?|(,*)/g, '')"	
						/>
						帝全售价(元)：
						<a-input-number
							placeholder="售价"
							:min="0.01"
							:precision="2"
							:formatter="value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
							:parser="value => value.replace(/\￥\s?|(,*)/g, '')"	
							:max="Number(domain.bazaarPrice)"
							style=" margin-right: 8px;width: 120px;"
							v-model="domain.price"
							@change="checkPrice(domain.price, domain.bazaarPrice)"
						/>
						<a-upload
							:action="QiniuURL"
							:data="QiniuData"
							:beforeUpload="beforeSpecificationPicUpload"
							listType="picture"
							:defaultFileList="domain.specificationPic"
							@preview="handlePreview"
							:remove="specificationPicRemove"
							:showUploadList="{showRemoveIcon: false }"
							supportServerRender
						>
							<a-button 
							v-if="domain.specificationPic == undefined || domain.specificationPic.length == 0"
							@click="specificationPicClick(index)">
								<a-icon type="upload" />
								商品图片(1张)
							</a-button>
						</a-upload>
						<a-icon
							v-if="dynamicValidateForm.domains.length > 1"
							class="dynamic-delete-button"
							type="minus-circle-o"
							:disabled="dynamicValidateForm.domains.length === 1"
							@click="removeDomain(domain)"
						/>
					</a-form-model-item>
					<a-form-model-item v-bind="formItemLayoutWithOutLabel">
						<a-button type="dashed" style="width: 60%" @click="addDomain(false)">
							<a-icon type="plus" />
							添加商品规格
						</a-button>
					</a-form-model-item>

					<a-form-model-item v-bind="formItemLayoutWithOutLabel">
						<a-button @click="last()">上一步，填写商品信息</a-button>
						<a-button type="primary" style="margin-left: 20px;" html-type="submit" :disabled="checkstoreInfoAll()" 
						 @click="showConfirm">完成，提交商品</a-button>
						<!-- <a-popconfirm
						    title="确定要重置所有信息吗 ?"
						    @confirm="confirm"
						    @cancel="cancel"
						    okText="Yes"
						    cancelText="No"
						  >
						    <a-button style="margin-left: 20px">重置</a-button>
						</a-popconfirm> -->
					</a-form-model-item>
				</a-form-model>
			</a-form-model>
		</a-card>
	</div>
</template>

<script>
import api from '../../../api/Api.js';
import axios from 'axios';

export default {
	inject:['reload'],
	data() {
		return {
			QiniuURL: 'https://upload-z2.qiniup.com', // 七牛云的上传地址（华南区）
			QiniuData: {
				key: '', //图片名字处理
				token: '' //七牛云token
			},
			bannerList: [],
			qiniuaddr: 'http://cdn.diqwl.com', // 七牛云的图片外链地址
			previewVisible: false,
			previewImage: '',
			pictureAddress: '',
			storeDetailList: [],
			storeInfo: {
				keyword: '',
				productName: '',
				classify: '',
				subhead: '',
				productSort: 0,
				serve: [],
				putAway: true,
				recommend: true,
				mallClassify: '',
				postage: true,
				onLinePay: false,
				minShop: 0,
				maxShop: 1,
				freight: 0,
				domains: [],
				
				detailDescribe:'',
				limit:0
			},
			domainDelete:[],
			zero: 'process',
			one: 'process',
			two: 'process',
			zeroDisabled: false,
			oneDisabled: false,
			twoDisabled: false,
			current: 0,
			commodityAttr: {},
			formItemLayout: {
				labelCol: {
					xs: { span: 24 },
					sm: { span: 4 }
				},
				wrapperCol: {
					xs: { span: 24 },
					sm: { span: 20 }
				}
			},
			formItemLayoutWithOutLabel: {
				wrapperCol: {
					xs: { span: 24, offset: 0 },
					sm: { span: 20, offset: 4 }
				}
			},
			dynamicValidateForm: {
				domains: []
			},
			typeList: [],
			treeData: [],
			index: 0,
			specificationPic: [],
			dialogImageUrl: '',
			dialogVisible: false,
			disabled: false
		};
	},
	watch : {
		productId:function(val,val2) {
			this.productId = val;
			this.getInfoCommodity();
		}
	},
	props:['productId'], /*通过props接收父组件传递过来的数据 */
	mounted() {
		this.getQiniuToken();
		this.getInfoType();
		this.getInfoCommodity();
		this.getMallType();
	},
	methods: {
		getInfoCommodity() {
			this.current = 0;
			const that = this;
			let url = 'api/store/v1/admin/commodity/commodityOfId';
			let parm = {
				id: this.productId
			};
		
			api.postRequest(url, parm, res => {
				if (res.status == 200) {
					that.bannerList = [];
					that.storeDetailList  = [];
					let storeInfoRes = res.data.data;
					storeInfoRes.putAway = that.numberToBool(storeInfoRes.putAway);
					storeInfoRes.recommend = that.numberToBool(storeInfoRes.recommend);
					storeInfoRes.limit = that.numberToBool(storeInfoRes.limit);
					
					storeInfoRes.onLinePay = that.numberToBool(storeInfoRes.onlinePay);
					// storeInfoRes.postage = that.numberToBool(storeInfoRes.postage);
					storeInfoRes.classify = storeInfoRes.typeId;
					storeInfoRes.mallClassify = storeInfoRes.mallClassify;
					// storeInfoRes.specificationList.specification   value
					that.bannerInfo(storeInfoRes.productPic);
					that.storeDetailInfo(storeInfoRes.productDetailPic);
					
					that.storeInfo  = storeInfoRes;
					that.dynamicValidateForm.domains[0] = {};
					that.dynamicValidateForm.domains[0].specificationPic = [];
					
					
					let specificationList = [];
					storeInfoRes.specificationList.forEach((item, index, arr) => {
						var obj = {
							status: 'done',
							uid : index,
							name : index + '.jpg',
							url : item.specificationPic,
							thumbUrl : item.specificationPic
						};
						item.price = item.price/100;
						item.bazaarPrice = item.bazaarPrice/100;
						
						specificationList.push(obj)
						
						item.value = item.specification;
						item.currentCnt = item.ku;
						item.specificationPic = [];
						item.specificationPicList = [];
						item.specificationPic.push(obj);
						item.specificationPicList.push(obj)
					});
					console.log(storeInfoRes.specificationList)
					that.dynamicValidateForm.domains = storeInfoRes.specificationList;
					that.index =  storeInfoRes.specificationList.length-1;
				} else {
					this.$message.waring(res.message);
				}
			});
		},
		checkBazaarPrice(bazzPrice,price,index) {
			this.dynamicValidateForm.domains[index].price = bazzPrice * 0.98;
		},
		checkPrice(price, bazzPrice) {
			if (bazzPrice == undefined) {
				this.$message.error('请填入市场价格！');
				this.okSubmit = false;
				return;
			}
			if (price > bazzPrice * 0.98) {
				this.$message.error('会员价应低于市场价的98折！');
				this.okSubmit = false;
				return;
			}
			this.okSubmit = true;
		},
		bannerInfo(bannerList) {
			if (bannerList == null) {
				return;
			}
			bannerList.forEach((item, index, arr) => {
				var obj = {
					status: 'done'
				};
				obj.uid = index;
				obj.name = index + '.jpg';
				obj.url = item;
				this.bannerList.push(obj);
			});
		},
		storeDetailInfo(storeDetailList) {
			if (storeDetailList == null) {
				return;
			}
			storeDetailList.forEach((item, index, arr) => {
				var obj = {
					status: 'done'
				};
				obj.uid = index;
				obj.name = index + '.jpg';
				obj.url = item;
				obj.thumbUrl = item;
				
				this.storeDetailList.push(obj);
			});
		},
		getInfoType() {
			const that = this;
			let url = 'api/store/v1/admin/commodity/typeList';
			let parm = {
				parentId: 0
			};
		
			api.postRequest(url, parm, res => {
				if (res.status == 200) {
					that.typeList = res.data.data;
				} else {
					this.$message.waring(res.message);
				}
			});
		},
		numberToBool(number) {
			if (number == 1) {
				return true;
			} else {
				return false;
			}
		},
		submitForm(formName) {
			const that = this;
			this.$refs[formName].validate(valid => {
				if (valid) {
					const bannerList = [];
					const storeDetailList = [];
					that.bannerList.forEach((item, index, array) => {
						bannerList.push(item.url);
					});
					that.storeDetailList.forEach((item, index, array) => {
						storeDetailList.push(item.url);
					});


					var obj = Object.assign(that.storeInfo, that.storePromotion);
					const specification = [];
					
					obj.productPic = bannerList;
					obj.productDetailPic = storeDetailList;
					
					if(that.dynamicValidateForm.domains.length == 0){
						this.$message.error("请填写规格")
						return;
					}
				
					that.dynamicValidateForm.domains.forEach((item, index, array) => {
						
						var temp = {};
						temp.specification = item.value;
						temp.ku = item.ku;
						temp.spId = item.spId;
						temp.isDelete = 0;
						temp.price = item.price*100;
						temp.bazaarPrice = item.bazaarPrice*100;
						temp.specificationPic = item.specificationPicList[0].url;
						specification.push(temp);
					});
					
					that.domainDelete.forEach((item, index, array) => {
						var temp = {};
						temp.specification = item.value;
						temp.ku = item.ku;
						temp.spId = item.spId;
						temp.isDelete = 1;
						temp.price = item.price*100;
						temp.bazaarPrice = item.bazaarPrice*100;
						temp.specificationPic = item.specificationPicList[0].url;
						specification.push(temp);
					});
					
					obj.specification = specification;
					obj.mallClassify = that.storeInfo.mallClassify;
					
					obj.putAway = that.booltoNumber(that.storeInfo.putAway);
					obj.recommend = that.booltoNumber(obj.recommend);
					obj.onLinePay = that.booltoNumber(that.storeInfo.onLinePay);
					obj.postage = that.booltoNumber(obj.postage);
					obj.limit = that.booltoNumber(obj.limit);
					obj.productId = that.productId;
					
					obj.specificationList = null;
					that.ModifyCommodity(obj);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		beforeSpecificationPicUpload(file,fileList) {
			const isPNG = file.type === 'image/png';
			const isJPEG = file.type === 'image/jpeg';
			const isJPG = file.type === 'image/jpg';
			const isLt2M = file.size / 1024 / 1024 < 2;
			
			if (!isPNG && !isJPEG && !isJPG) {
				this.$message.error('上传图片只能是 jpg、png、jpeg 格式!');
				return false;
			}
			if (!isLt2M) {
				this.$message.error('上传图片大小不能超过 2MB!');
				return false;
			}
			this.QiniuData.key = localStorage.getItem('accessToken')+Date.parse(new Date());
			this.pictureAddress = this.qiniuaddr + '/' + this.QiniuData.key;
			
			var obj = {
				status: 'done'
			};
			obj.uid = file.uid;
			obj.name = this.QiniuData.key;
			obj.url = this.pictureAddress;
			obj.thumbUrl = this.pictureAddress;
			obj.status = 'done';
			
			if(this.dynamicValidateForm.domains[this.index].specificationPicList == undefined){
				this.dynamicValidateForm.domains[this.index].specificationPicList = [];
			}
			if(this.dynamicValidateForm.domains[this.index].specificationPicList.length > 0){
				return false;
			}
			
			let temp = this.dynamicValidateForm;
			this.dynamicValidateForm = [];
			this.dynamicValidateForm = temp;
			
			console.log(obj.url);
			this.dynamicValidateForm.domains[this.index].specificationPicList.push(obj);
			
		},
		specificationPicRemove(file) {
			const specificationPicList = this.dynamicValidateForm.domains[0].specificationPic;
			
			var index = specificationPicList.findIndex(item => {
				if (item.uid == file.uid) {
					return true;
				}
			});
			
			specificationPicList.splice(index, 1);
		},
		ModifyCommodity(pram) {
			const that = this;
			let url = 'api/store/v1/admin/commodity/modifyCommodity';
			let parm = pram;
		
			api.postRequest(url, parm, res => {
				if (res.data.status == 200) {
					this.$message.success("修改成功！")
					that.getInfoCommodity();
					this.$emit('event1', false)
				} else {
					console.log(res)
					this.$message.error(res.message);
				}
			});
		},
		confirm(e) {
			this.resetForm();
		},
		cancel(e) {
			console.log(e);
		},
		resetForm() {
			this.storeInfo.maxShop = 0;
			this.storeInfo.minShop = 0;
			this.storeInfo.name = '';
			this.storeInfo.classify = '' ;
			this.storeInfo.subhead = '';
			this.storeInfo.productSort = 0;
			this.storeInfo.keyword = '';
			this.storeInfo.detailDescribe ='';
			this.storeInfo.mallClassify = '';
			this.bannerList = [];
			this.storeDetailList = [];
			this.$refs["dynamicValidateForm"].resetFields();
			this.dynamicValidateForm.domains = [];
			this.one = 'wait';
			this.two = 'wait';
			this.oneDisabled = true;
			this.twoDisabled = true;
			this.current = 0;
			this.addDomain(true);
		},
		specificationPicClick(index) {
			this.index = index;
		},
		booltoNumber(bool) {
			if (bool) {
				return 1;
			} else {
				return 0;
			}
		},
		handleCancel() {
			this.previewVisible = false;
		},
		bannerRemove(file) {
			var index = this.bannerList.findIndex(item => {
				if (item.uid == file.uid) {
					return true;
				}
			});
			this.bannerList.splice(index, 1);
		},
		bannerDetailRemove(file) {
			var index = this.storeDetailList.findIndex(item => {
				if (item.uid == file.uid) {
					return true;
				}
			});
			this.storeDetailList.splice(index, 1);
		},
		handlePreview(file) {
			this.previewImage = file.url || file.thumbUrl;
			this.previewVisible = true;
		},
		beforeStoreUpload(file) {
			const isPNG = file.type === 'image/png';
			const isJPEG = file.type === 'image/jpeg';
			const isJPG = file.type === 'image/jpg';
			const isLt2M = file.size / 1024 / 1024 < 2;

			if (!isPNG && !isJPEG && !isJPG) {
				this.$message.error('上传图片只能是 jpg、png、jpeg 格式!');
				return false;
			}
			if (!isLt2M) {
				this.$message.error('上传图片大小不能超过 2MB!');
				return false;
			}
			this.QiniuData.key = localStorage.getItem('accessToken')+Date.parse(new Date());
			this.pictureAddress = this.qiniuaddr + '/' + this.QiniuData.key;
		},
		beforeStoreDetailUpload(file) {
			const isPNG = file.type === 'image/png';
			const isJPEG = file.type === 'image/jpeg';
			const isJPG = file.type === 'image/jpg';
			const isLt2M = file.size / 1024 / 1024 < 2;

			if (!isPNG && !isJPEG && !isJPG) {
				this.$message.error('上传图片只能是 jpg、png、jpeg 格式!');
				return false;
			}
			if (!isLt2M) {
				this.$message.error('上传图片大小不能超过 2MB!');
				return false;
			}
			this.QiniuData.key = localStorage.getItem('accessToken')+Date.parse(new Date());
			this.pictureAddress = this.qiniuaddr + '/' + this.QiniuData.key;
		},
		getMallType() {
			const that = this;
			let url = 'api/store/v1/admin/mall/list/withChildren';
			let parm = '1';
			
			api.postRequest(url, parm, res => {
				if (res.status == 200) {
					that.mallTypeList = res.data.data;
					var obj={
						id: 2,
						name: "数码电子"
					}
					that.mallTypeList.splice(0, 0, obj);
					// that.mallTypeList.shift()
					that.mallTypeList.pop()
				} else {
					this.$message.waring(res.message);
				}
			});
		},
		onSubmit() {
			this.current++;
			console.log('商品信息!', this.storeInfo);
			console.log('商品促销!', this.storePromotion);
		},
		checkstoreInfoAll() {
			if (this.checkStoreInfo() || this.checkstorePromotion()) {
				return true;
			}
			if (this.bannerList.length == 0 || this.storeDetailList.length == 0) {
				return true;
			}
			return false;
		},
		checkStoreInfo() {
			var form = this.storeInfo;
			if (
				form.name == '' ||
				form.classify == ''
			) {
				this.oneDisabled = true;
				this.one = 'wait';
				return true;
			} else {
				this.oneDisabled = false;
				this.one = 'process';
				return false;
			}
		},
		checkstorePromotion() {
			var form = this.storeInfo;
			//console.log(form.keyword)
			if ( form.recommend == false) {
				this.twoDisabled = false;
				this.two = 'process';
				return false;
			}else if (form.recommend == true && form.mallClassify != '') {
				this.twoDisabled = false;
				this.two = 'process';
				return false;
			}else {
				this.twoDisabled = true;
				this.two = 'wait';
				return true;
			}
		},
		last() {
			this.current --;
		},
		step(current) {
			console.log(this.current);
		},
		removeDomain(item) {
			let index = this.dynamicValidateForm.domains.indexOf(item);
			
			if (index !== -1) {
				var obj = this.dynamicValidateForm.domains[index];
				if(obj != undefined && obj.spId != undefined){
					obj.isDelete = 1;
					this.domainDelete.push(obj)	
				}
				console.log(obj)
				this.dynamicValidateForm.domains.splice(index, 1);
				var temp = this.dynamicValidateForm.domains;
				this.dynamicValidateForm.domains = [];
				let that = this;
				setTimeout(function(){
					that.dynamicValidateForm.domains =temp;
					console.log("============================================")
				},0)
			}
		},
		addDomain(bool) {
			if(!bool){
				if (this.dynamicValidateForm.domains[this.index].specificationPicList == undefined || this.dynamicValidateForm.domains[this.index].specificationPicList.length == 0) {
					this.$message.error("请完善商品规格信息！")
					return;
				}
			}
			this.index = this.index + 1;
			
			this.dynamicValidateForm.domains.push({
				value: '',
				key: Date.now(),
				currentCnt: 0,
				bazaarPrice: 0,
				price: 0,
				specificationPic: []
			});
		},
		showConfirm() {
			
			var that = this;
		
		  this.$confirm({
			title: '确认修改商品信息吗?',
			content: '修改图片、商品标题等内容，商品将会重新进入审核，确认修改？',
			okText:'确认修改',
			cancelText :'取消',
			onOk() {
			  return new Promise((resolve, reject) => {
				that.submitForm('dynamicValidateForm');
				setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
			  }).catch(() => console.log('Oops errors!'));
			},
			onCancel() {},
		  });
		},
		//请求后台拿七牛云token
		getQiniuToken() {
			const that = this;
			let url = 'api/file/v1/qiniu/getToken';
			let parm = 1;
			
			api.postRequest(url, parm, res => {
				if (res.data.status == 200) {
					this.QiniuData.token = res.data.data.token;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		uploadSuccess(response, file, fileList) {
			this.uploadPicUrl = `${this.qiniuaddr}/${response.key}`;
			var obj = {
				status: 'done'
			};
			obj.uid = file.uid;
			obj.name = this.QiniuData.key;
			obj.url = this.pictureAddress;
			this.bannerList.push(obj);
		},
		uploadSuccessUpload(response, file, fileList) {
			this.uploadPicUrl = `${this.qiniuaddr}/${response.key}`;
			var obj = {
				status: 'done'
			};
			obj.uid = file.uid;
			obj.name = this.QiniuData.key;
			obj.url = this.pictureAddress;
			
			console.log(obj.url);
			
			this.storeDetailList.push(obj);
		},
		uploadError(err, file, fileList) {
			this.$message.error("上传出错，请重试!");
		},
		handleExceed(files, fileList) {
			this.$message.warning(`图片选择已上限，如需更换，请删除上一张图片在重新选择！`);
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		refleush(index){
			let temp = this.dynamicValidateForm;
			this.dynamicValidateForm = [];
			this.dynamicValidateForm = temp;
		}
	}
};
</script>
<style>
#components-form-demo-validate-other .dropbox {
	height: 180px;
	line-height: 1.5;
}
.dynamic-delete-button {
	cursor: pointer;
	position: relative;
	top: 4px;
	font-size: 24px;
	color: #999;
	transition: all 0.3s;
}
.dynamic-delete-button:hover {
	color: #777;
}
.dynamic-delete-button[disabled] {
	cursor: not-allowed;
	opacity: 0.5;
}

/* tile uploaded pictures */
.upload-list-inline >>> .ant-upload-list-item {
	float: left;
	width: 200px;
	margin-right: 8px;
}
.upload-list-inline >>> .ant-upload-animate-enter {
	animation-name: uploadAnimateInlineIn;
}
.upload-list-inline >>> .ant-upload-animate-leave {
	animation-name: uploadAnimateInlineOut;
}
</style>
